import { QueryCache, QueryClient } from '@tanstack/react-query'

import { ONE_MINUTE_MILLISECONDS } from '@/lib/date'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 0,
			staleTime: ONE_MINUTE_MILLISECONDS,
			gcTime: Infinity,
		},
	},
	queryCache: new QueryCache({
		onError: error => {
			// TODO log error
			console.error(error)
		},
	}),
})
